import { PagesPaths } from '@/enums';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faHouse,
  faAnchor,
  faShip,
  faBox,
  faBoxesStacked,
  faCalculator,
  faCheckToSlot,
  faFileInvoice,
  faDollarSign,
  faMoneyBill1Wave,
  faFileLines,
} from '@fortawesome/free-solid-svg-icons';
import { TFunction } from 'i18next';

export type MenuItem = {
  label: string;
  icon?: IconDefinition;
  to?: string;
  items?: MenuItem[];
  name?: string;
};

export const getPublicMenuItems = (
  translates: TFunction<'menu', undefined>
): MenuItem[] => {
  return [
    {
      label: translates('costSimulator'),
      to: PagesPaths.CostSimulator,
      icon: faCalculator,
    },
    {
      label: translates('eir'),
      to: PagesPaths.EIR,
      icon: faCheckToSlot,
    },
    {
      label: translates('eInvoice'),
      to: PagesPaths.EInvoice,
      icon: faFileInvoice,
    },
  ];
};

const checkAccess = (item: MenuItem, accessPages: string[]): boolean => {
  if (!item?.to && !item?.items?.length) return false;
  if (!item.name) return true;
  return accessPages.includes(item.name);
};

const filterSubMenuItems = (item: MenuItem, accessPages: string[]) => {
  const response = item;
  if (item.items) {
    response.items = item.items.filter((subItem) => {
      return checkAccess(subItem, accessPages);
    });
  }
  return response;
};

export const getprivateMenuItems = (
  translates: TFunction<'menu', undefined>,
  accessPages: string[] = []
): MenuItem[] => {
  const privateMenuItems: MenuItem[] = [
    {
      label: translates('init'),
      to: PagesPaths.PrivateHome,
      icon: faHouse,
    },
    {
      label: translates('schedule'),
      icon: faAnchor,
      to: PagesPaths.Schedule,
    },
    {
      label: translates('ships'),
      icon: faShip,
      items: [
        {
          label: translates('searchByBooking'),
          to: PagesPaths.SearchByBooking,
          name: 'Buques_BusquedaPorBooking',
        },
        {
          label: translates('containerList'),
          to: PagesPaths.ContainerList,
          name: 'Buques_ContainerList',
        },
        {
          label: translates('assignList'),
          to: PagesPaths.AssignList,
          name: 'Buques_ListaDeAsignacion',
        },
        {
          label: translates('unloadingList'),
          to: PagesPaths.UnloadingList,
          name: 'Buques_ListaDeDescarga',
        },
        {
          label: translates('solas'),
          to: PagesPaths.SOLAS,
          name: 'Buques_SOLAS',
        },
      ],
    },
    {
      label: translates('containers'),
      icon: faBox,
      items: [
        {
          label: translates('numeroStock'),
          to: PagesPaths.NumberStock,
          name: 'Contenedores_NumeroDeStock',
        },
        {
          label: translates('deliveryOrder'),
          to: PagesPaths.DeliveryOrder,
          name: 'Contenedores_DeliveryOrder',
        },
        {
          label: translates('containerTap'),
          to: PagesPaths.ContainerTap,
          name: 'Contenedores_FichaContenedor',
        },
        {
          label: translates('containerReleaseImport'),
          to: PagesPaths.ContainerRelease,
          name: 'Contenedores_LiberacionImportacion',
        },
      ],
    },
    {
      label: translates('stock'),
      icon: faBoxesStacked,
      name: 'Menu_stock',
      items: [
        {
          label: translates('exchanges'),
          to: PagesPaths.Exchanges,
          name: 'Stock_ParteIntercambios',
        },
        {
          label: translates('stockSummary'),
          to: PagesPaths.StockSummary,
          name: 'Stock_ResumenStock',
        },
        {
          label: translates('exportContainers'),
          to: PagesPaths.StockContainers,
        },
        /*  {
          label: translates('loadForecast'),
          to: PagesPaths.PronosticoCarga,
          name: 'Stock_PronosticoCarga',
        }, */
        {
          label: translates('detailedStock'),
          to: PagesPaths.DetailedStock,
        },
      ],
    },
    {
      label: translates('settlements'),
      icon: faDollarSign,
      items: [
        {
          label: translates('mySettlement'),
          to: PagesPaths.mySettlement,
          name: 'Liquidaciones_MisLiquidaciones',
        },
        {
          label: translates('documentsWeb'),
          to: PagesPaths.documentsWeb,
          name: 'Liquidaciones_MisDocumentos',
        },
        {
          label: translates('generateWorkOrder'),
          to: PagesPaths.OrdenDeTrabajo,
          name: 'Liquidaciones_GenerarOrdenANPBookin',
        },
        {
          label: translates('costumerRegistration'),
          to: PagesPaths.CustomerRegistration,
          name: 'Liquidaciones_AltaTitularNexys',
        },
        {
          label: translates('paymentInquiry'),
          to: PagesPaths.paymentInquiry,
        },
        {
          label: translates('scheduleDetail'),
          to: PagesPaths.ScheduleDetail,
        },
      ],
    },
    {
      label: translates('payments'),
      icon: faMoneyBill1Wave,
      items: [
        {
          label: translates('accountStatement'),
          to: PagesPaths.accountStatement,
          name: 'Estado_de_Cuenta',
        },
        {
          label: translates('pendingPayments'),
          to: PagesPaths.paymentPendings,
        },
      ],
    },
    {
      label: translates('documentsHistory'),
      to: PagesPaths.documentsHistory,
      icon: faFileLines,
    },
  ];

  if (!accessPages.length) return privateMenuItems;

  const response = privateMenuItems
    .map((item) => filterSubMenuItems(item, accessPages))
    .filter((item) => checkAccess(item, accessPages));
  return response;
};
